<template>
  <div>
    <div v-if="conceptPayments.length > 0" class="row">
      <hr />
      <h2 class="col-12 mb-4">{{ orderId ? 'Pagos del pedido' : 'Pagos del recibo' }}</h2>

      <div class="col-sm-12 mb-3 d-none d-sm-block">
        <div class="row">
          <div class="col-sm-1"><h4>#</h4></div>
          <div class="col-sm-2"><h4>Tipo</h4></div>
          <div class="col-sm-2"><h4>Importe</h4></div>
          <div class="col-sm-2"><h4>Banco</h4></div>
          <div class="col-sm-2"><h4>Código Postal</h4></div>
          <div class="col-sm-2"><h4>Fecha de Acreditación</h4></div>
        </div>
      </div>

      <div class="col-12">
        <div v-for="(item, index) in conceptPayments" :key="index" class="row">
          <div class="col-sm-1">
            <small>{{ item.number ? item.number : '---' }}</small>
          </div>
          <div class="col-sm-2">
            <small>{{ item.conceptPaymentType ? item.conceptPaymentType.description : '---' }}</small>
          </div>
          <div class="col-sm-2">
            <small>{{ item.amountInPesos | toCurrencyARS }}</small>
          </div>
          <div class="col-sm-2">
            <small>{{ item.bank ? item.bank : '---' }}</small>
          </div>
          <div class="col-sm-2">
            <small>{{ item.postalCode ? item.postalCode : '----' }}</small>
          </div>
          <div class="col-sm-2">
            <small>{{ item.accreditationDate | date }}</small>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'PaymentDetail',
  props: {
    receipt: {
      type: Object,
      default: null,
    },

    orderId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      conceptPayments: [],
    };
  },

  mounted() {
    this.fetchConceptPayments();
  },

  methods: {
    fetchConceptPayments() {
      const filter = this.receipt ? { 'filter[receipt_id]': this.receipt.id } : { 'filter[order_id]': this.orderId };
      const params = {
        ...filter,
        include: 'conceptPaymentType',
      };

      this.$services
        .resource('concept_payments')
        .get(params)
        .then(({ data }) => {
          this.conceptPayments = data.data.conceptPayments;
        });
    },
  },
};
</script>
